export default "__VITE_ASSET__C61miGmU__"